import './assets/css/style.scss';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomeV2 from './components/v2/home/HomeV2';
import { AppProvider } from './context/AppContext';
import Articles from './components/v2/Articles/Article/Articles';
import Wishlist from './components/v2/Wishlist/Wishlist';
import ArticleDetailsV3 from './components/ArticleDetailsV3/ArticleDetailsV3';
import { ToastContainer } from 'react-toastify';
import HeaderV2 from './components/elements/Header/HeaderV2';
import FooterV2 from './components/elements/Footer/FooterV2';
import Branch from "./components/Branch/Branch";

function App() {
  return (
    <AppProvider>
      <div className="app">
        <ToastContainer position="top-right" autoClose={3000} />

        <BrowserRouter>
          <HeaderV2 />
          <Routes>
            <Route path="/" element={<HomeV2 />} />
            <Route path="/home" element={<HomeV2 />} />
            <Route path="/artikuj" element={<Articles />} />
            <Route path="/artikull/:id" element={<ArticleDetailsV3 />} />
            <Route path="/filiali/:city" element={<Branch />} />
            <Route path="/botime" element={<Wishlist />} />
          </Routes>
          <FooterV2 />
        </BrowserRouter>
      </div>
    </AppProvider>
  );
}

export default App;
